module.exports = __webpack_public_path__ + "7909efcc1392cd90bbe0e03ea0b6c273.MP3";